import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'

import DatePicker from '@components/shared/date-picker'
import Form from '../../shared/form'
import FormSwitch from '../../shared/form-switch'
import ResponsiveDialog from '../../shared/responsive-dialog'
import TimePicker from '@components/shared/time-picker'
import { Button, DialogActions } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { useAllActions } from '@hooks'

const useStyles = makeStyles()(() => ({
  form: {
    minWidth: 600,
  },
  fieldWrapper: {
    marginBottom: 15,
  },
  fieldSpan: {
    marginBottom: 15,
  },
}))

function HolidayHourDialog(props) {
  const { classes } = useStyles()
  const [date, setDate] = useState('')
  const [closed, setClosed] = useState(false)
  const [holiday, setHoliday] = useState(false)
  const [opens, setOpens] = useState('')
  const [closes, setCloses] = useState('')
  const { setFlashMessage } = useAllActions()

  useEffect(() => {
    if (props.storeHour) {
      const {
        override_date,
        is_closed,
        is_holiday,
        opening_time,
        closing_time,
      } = props.storeHour
      setDate(override_date)
      setOpens(opening_time)
      setCloses(closing_time)
      setClosed(is_closed)
      setHoliday(is_holiday)
    } else {
      setDate('')
      setOpens('')
      setCloses('')
      setClosed(false)
      setHoliday(false)
    }
  }, [props.storeHour])

  const getData = () => {
    if (!date) throw new Error('Please enter a date.')

    if (!closed && !opens)
      throw new Error('Please enter an opening time (unless store closed)')

    if (!closed && !closes)
      throw new Error('Please enter a closing time (unless store closed)')

    const data = {
      store_id: props.storeId,
      override_date: date,
      is_closed: closed,
      is_holiday: holiday,
    }

    if (opens) data.opening_time = opens
    if (closes) data.closing_time = closes
    return data
  }

  return (
    <ResponsiveDialog
      loading={props.loading}
      onClose={props.onClose}
      open={props.open}
    >
      <Form
        className={classes.form}
        paper={false}
        title={props.storeHour ? 'Edit Holiday' : 'Create Holiday'}
      >
        <div className={classes.fieldWrapper}>
          <div>Date</div>
          <DatePicker date={date} onChange={setDate} />
        </div>
        {!closed && (
          <>
            <div className={classes.fieldWrapper}>
              <div>Opens</div>
              <TimePicker onChange={setOpens} time={opens} />
            </div>
            <div className={classes.fieldWrapper}>
              <div>Closes</div>
              <TimePicker onChange={setCloses} time={closes} />
            </div>
          </>
        )}
        <FormSwitch
          checked={closed}
          fullWidth={false}
          onChange={() => setClosed(!closed)}
          title='Is Closed'
        />
        <FormSwitch
          checked={holiday}
          fullWidth={false}
          onChange={() => setHoliday(!holiday)}
          title='Is Holiday'
        />
      </Form>
      <DialogActions>
        <Button onClick={props.onClose}>Cancel</Button>
        <Button
          onClick={() => {
            try {
              const data = getData()
              props.onSubmit(data)
            } catch (error) {
              setFlashMessage(error.message, 'error')
            }
          }}
        >
          {props.storeHour ? 'Save' : 'Create'}
        </Button>
      </DialogActions>
    </ResponsiveDialog>
  )
}

HolidayHourDialog.propTypes = {
  storeId: PropTypes.number,
  storeHour: PropTypes.object,
  onClose: PropTypes.func,
  open: PropTypes.bool,
  loading: PropTypes.bool,

  /**
   * Method called when the form is submitted (with valid data). It will
   * send (full) data for the holiday.
   */
  onCreate: PropTypes.func,
}

export default HolidayHourDialog
